import { useMemo } from 'react';
import SubmitSelectionButton from '../SubmitSelectionButton';
import OrderSummaryComponent from 'components/checkout/OrderSummary';
import { useCheckout } from 'features/organizations/memberships/checkout/context';
import DiscountCodeBanner from '../../../../DiscountCodeBanner';

const OrderSummary = () => {
  const { user, cart, appliedDiscount } = useCheckout();

  // Create array of ticket items from selected tickets
  const summaryProducts = useMemo(() => {
    if (cart.isEmpty) {
      return [];
    }

    return Object.entries(cart.selectedProducts).map(
      ([_, selectedProduct]) => ({
        id: selectedProduct.productData.product.id,
        quantity: selectedProduct.metadata.quantity,
        title: selectedProduct.productData.product.name,
        price: selectedProduct.productData.product.price
      })
    );
  }, [cart.selectedProducts, cart.isEmpty]);

  // Convert discount code to the format expected by OrderSummary
  // Note: We only need id, code, and discount fields for the applyDiscount function
  const discountData = appliedDiscount.data
    ? ({
        id: appliedDiscount.data.id,
        code: appliedDiscount.data.code,
        discount: appliedDiscount.data.discount
      } as any)
    : null;

  return (
    <OrderSummaryComponent
      hasTierNav={false}
      isUserLoggedIn={!!user}
      discountData={discountData}
      tierRequiringApproval={false}
      selectedProducts={summaryProducts}
      AdditionalOrderInfo={
        appliedDiscount.data && (
          <DiscountCodeBanner discountCode={appliedDiscount.data} />
        )
      }
      Actions={<SubmitSelectionButton />}
    />
  );
};

export default OrderSummary;
